import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import ZoomPlugin from 'chartjs-plugin-zoom';
import { Bar } from 'react-chartjs-2';
import { Flex } from 'styled-system/jsx';
import {
  generateWalletYearlyReportChartData,
  yearlyReportBarChartOptions,
} from '../../data/generateWalletYearlyReportChartData';
import { WalletYearlyReportQueryResponseType } from '../../queries/walletYearlyReport/walletYearlyReportMutation.type';

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ZoomPlugin,
);

export default function YearlyReportChart({
  monthList,
}: {
  monthList: WalletYearlyReportQueryResponseType['months'];
}) {
  const cookedData =
    monthList && generateWalletYearlyReportChartData(monthList);
  return (
    <Flex overflowX={'auto'} overflowY={'hidden'} mt={12}>
      <Bar
        data={cookedData}
        options={(yearlyReportBarChartOptions as any) || {}}
      />
    </Flex>
  );
}
